import AppRecord from './AppRecord.js'

class SailsLogCheck extends AppRecord {

}

export default SailsLogCheck
